<template>
  <header class="modern-navbar">
    <nav class="navbar-container" id="nav">
      <!-- Logo Section -->
      <a href="http://cowlardesignstudio.com" target="_blank" class="logo-link">
        <div class="logo-container" id="logo">
          <img
            alt="Cowlar Logo"
            src="../assets/CowlarLogo.svg"
            class="logo-image"
          />
        </div>
      </a>

      <!-- Mobile Menu Toggle -->
      <button
        class="mobile-toggle"
        id="myButton"
        aria-label="Toggle navigation"
        @click="toggleMobileMenu"
      >
        <span class="hamburger-icon" id="hamburger">
          <span class="bar bar-1"></span>
          <span class="bar bar-2"></span>
          <span class="bar bar-3"></span>
        </span>
      </button>

      <!-- Navigation Menu -->
      <div class="navbar-menu" id="navbarNavAltMarkup">
        <div class="nav-items">
          <a
            class="nav-item"
            href="http://cowlardesignstudio.com"
            target="_blank"
          >
            <span class="nav-text">Home</span>
            <span class="nav-indicator"></span>
          </a>

          <!-- <a
            class="nav-item"
            @click="scrollToSection('#culture-banner'); closeMobileMenu();"
          >
            <span class="nav-text">Culture</span>
            <span class="nav-indicator"></span>
          </a> -->

          <a
            class="nav-item"
            @click="
              scrollToSection('#careers');
              closeMobileMenu();
            "
          >
            <span class="nav-text">Open Positions</span>
            <span class="nav-indicator"></span>
          </a>

          <a
            class="nav-item"
            @click="
              scrollToSection('#prep-docs');
              closeMobileMenu();
            "
          >
            <span class="nav-text">Prep Docs</span>
            <span class="nav-indicator"></span>
          </a>

          <!-- <a
            class="nav-item"
            @click="scrollToSection('#values'); closeMobileMenu();"
          >
            <span class="nav-text">Our Teams</span>
            <span class="nav-indicator"></span>
          </a> -->

          <a
            class="nav-item"
            @click="
              scrollToSection('#hiringProcess');
              closeMobileMenu();
            "
          >
            <span class="nav-text">Hiring Process</span>
            <span class="nav-indicator"></span>
          </a>

          <a
            class="nav-item"
            @click="
              scrollToSection('#contact');
              closeMobileMenu();
            "
          >
            <span class="nav-text">Contact Us</span>
            <span class="nav-indicator"></span>
          </a>

          <!-- Mobile Footer -->
          <div class="mobile-footer">
            <div class="footer-text">
              © 2025 Cowlar Design Studio. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isMobileMenuOpen: false,
      cowlarUrl: process.env.VUE_APP_COWLAR_URL,
    };
  },
  mounted() {
    // Add scroll effect
    window.addEventListener("scroll", this.handleScroll);

    // Initialize hamburger animation
    this.initializeHamburger();
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const navbar = document.querySelector(".modern-navbar");
      if (window.scrollY > 50) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    },

    scrollToSection(sectionId) {
      const section = document.querySelector(sectionId);
      if (section) {
        const offset = section.offsetTop - 80;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    },

    closeMobileMenu() {
      const navbarToggle = document.getElementById("myButton");
      const navbarCollapse = document.getElementById("navbarNavAltMarkup");
      const hamburger = document.getElementById("hamburger");

      if (navbarToggle) navbarToggle.setAttribute("aria-expanded", "false");
      if (navbarCollapse) navbarCollapse.classList.remove("show");
      if (hamburger) hamburger.classList.remove("active");
      document.body.classList.remove("menu-open");
      this.isMobileMenuOpen = false;
    },

    toggleMobileMenu() {
      const navbarToggle = document.getElementById("myButton");
      const navbarCollapse = document.getElementById("navbarNavAltMarkup");
      const hamburger = document.getElementById("hamburger");

      const isOpen =
        navbarCollapse?.classList.contains("show") || this.isMobileMenuOpen;

      if (isOpen) {
        // Close menu
        if (navbarToggle) navbarToggle.setAttribute("aria-expanded", "false");
        if (navbarCollapse) navbarCollapse.classList.remove("show");
        if (hamburger) hamburger.classList.remove("active");
        document.body.classList.remove("menu-open");
        this.isMobileMenuOpen = false;
      } else {
        // Open menu
        if (navbarToggle) navbarToggle.setAttribute("aria-expanded", "true");
        if (navbarCollapse) navbarCollapse.classList.add("show");
        if (hamburger) hamburger.classList.add("active");
        document.body.classList.add("menu-open");
        this.isMobileMenuOpen = true;
      }
    },
  },
};
</script>

<style scoped>
.modern-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(26, 26, 26, 0.85);
  backdrop-filter: blur(1.25rem);
  border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  padding: 0;
}

.modern-navbar.scrolled {
  background: rgba(26, 26, 26, 0.95);
  backdrop-filter: blur(1.5625rem);
  border-bottom-color: rgba(244, 119, 38, 0.2);
  box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.3);
}

.navbar-container {
  max-width: 87.5rem;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-link {
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo-link:hover {
  transform: scale(1.05);
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-image {
  height: 2.5rem;
  width: auto;
  transition: all 0.3s ease;
}

.mobile-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 1rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  z-index: 10000;
}

.mobile-toggle:hover {
  background: rgba(244, 119, 38, 0.1);
}

.hamburger-icon {
  display: flex;
  flex-direction: column;
  width: 1.5rem;
  height: 1.125rem;
  position: relative;
  justify-content: center;
  align-items: center;
}

.bar {
  width: 100%;
  height: 0.125rem;
  background: #ffffff;
  border-radius: 0.125rem;
  transition: all 0.3s ease;
  transform-origin: center;
  position: absolute;
}

.bar-1 {
  top: 0;
}

.bar-2 {
  top: 50%;
  transform: translateY(-50%);
}

.bar-3 {
  bottom: 0;
}

.hamburger-icon.active .bar-1 {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.hamburger-icon.active .bar-2 {
  opacity: 0;
  transform: translateY(-50%) scaleX(0);
}

.hamburger-icon.active .bar-3 {
  bottom: auto;
  top: 50%;
  transform: translateY(-50%) rotate(-45deg);
}

.navbar-menu {
  display: flex;
  align-items: center;
}

.nav-items {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: "Manrope", sans-serif;
}

.nav-item {
  position: relative;
  padding: 0.75rem 1.25rem;
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.1rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
}

.nav-text {
  position: relative;
  z-index: 2;
  color: #ffffff;
  transition: color 0.3s ease;
}

.nav-indicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0.125rem;
  background: linear-gradient(90deg, #f47726 0%, #ff9a56 100%);
  transform: translateX(-50%);
  transition: width 0.3s ease;
  border-radius: 0.0625rem;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.05);
  transform: translateY(-0.0625rem);
}

.nav-item:hover .nav-indicator {
  width: 70%;
}

.mobile-footer {
  display: none;
}

.footer-text {
  color: #9da3bf;
  font-size: 0.8rem;
  text-align: center;
  margin-top: 2rem;
}

@media (max-width: 75rem) {
  .navbar-container {
    padding: 0.8rem 1.5rem;
  }

  .mobile-toggle {
    display: block;
  }

  .navbar-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: linear-gradient(
      135deg,
      rgba(26, 26, 26, 0.98) 0%,
      rgba(42, 42, 42, 0.98) 100%
    );
    backdrop-filter: blur(1.875rem);
    transform: translateX(-100%);
    transition: transform 0.4s ease;
    opacity: 0;
    visibility: hidden;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .navbar-menu.show {
    transform: translateX(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-items {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: 2rem;
    padding: 2rem;
    text-align: center;
    width: 100%;
    max-width: 25rem;
  }

  .nav-item {
    font-size: 1.8rem;
    font-weight: 600;
    padding: 1.2rem 2.5rem;
    text-align: center;
    width: 100%;
    max-width: 17.5rem;
    border: 0.0625rem solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.02);
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-item:hover {
    background: rgba(244, 119, 38, 0.1);
    border-color: rgba(244, 119, 38, 0.3);
    transform: translateY(-0.125rem) scale(1.02);
  }

  .mobile-footer {
    display: block;
    position: absolute;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    width: 100%;
  }

  .logo-image {
    height: 2rem;
  }
}

@media (min-width: 75.0625rem) {
  .navbar-menu {
    display: flex !important;
    position: static !important;
    transform: none !important;
    opacity: 1 !important;
    visibility: visible !important;
    background: none !important;
    backdrop-filter: none !important;
    width: auto !important;
    height: auto !important;
  }

  .mobile-toggle {
    display: none !important;
  }

  .nav-items {
    display: flex !important;
    flex-direction: row !important;
    height: auto !important;
    padding: 0 !important;
  }

  .mobile-footer {
    display: none !important;
  }
}

@media (max-width: 48rem) {
  .navbar-container {
    padding: 0.6rem 1rem;
  }

  .nav-item {
    font-size: 1.6rem;
    max-width: 16.25rem;
    padding: 1rem 2rem;
  }

  .logo-image {
    height: 1.75rem;
  }

  .hamburger-icon {
    width: 1.375rem;
    height: 1rem;
  }
}

@media (max-width: 30rem) {
  .navbar-container {
    padding: 0.5rem 0.8rem;
  }

  .nav-item {
    font-size: 1.4rem;
    padding: 0.9rem 1.8rem;
    max-width: 15rem;
  }

  .logo-image {
    height: 1.5rem;
  }

  .hamburger-icon {
    width: 1.25rem;
    height: 0.875rem;
  }

  .nav-items {
    gap: 1.5rem;
    max-width: 20rem;
  }
}

:global(body.menu-open) {
  overflow: hidden;
}
</style>
